import { querySelector, querySelectorAll } from './querySelectors';
import { FORM_ROW_CLASS, FORM_ROW_ERROR_CLASS } from '../config/main';

let inputChange = function() {
  let row = this.closest(`.${FORM_ROW_CLASS}`);
  let inputs = querySelectorAll(`input[name="${this.getAttribute('name')}"]`, this.closest('form'));

  row.classList.remove(FORM_ROW_ERROR_CLASS);
  inputs.forEach((input) => {
    input.removeEventListener('change', inputChange);
  });
};

export default function(radios, form) {
  let radiosNames = [];
  let allow = true;

  radios.forEach((radio) => {
    if (radiosNames.indexOf(radio.getAttribute('name')) === -1) {
      radiosNames.push(radio.getAttribute('name'));
    }
  });

  radiosNames.forEach((name) => {
    let inputs = querySelectorAll(`input[name="${name}"]`, form);

    if (inputs.length) {
      let row = inputs[0].closest(`.${FORM_ROW_CLASS}`);

      if (querySelector(`input[name="${name}"]:checked`, form)) {
        row.classList.remove(FORM_ROW_ERROR_CLASS);
      }
      else {
        allow = false;
        row.classList.add(FORM_ROW_ERROR_CLASS);

        inputs.forEach((input) => {
          input.addEventListener('change', inputChange);
        });
      }
    }
  });

  return allow;
}
